import React from 'react';
import './LuxuryExperiences.css';

const LuxuryExperiences = () => {
  return (
    <section className="luxury-experiences">
      <div className="experiences-container">
        {/* Safari Experience */}
        <div className="experience-item">
          <div className="experience-content">
            <h3>Luxury Safari Experiences</h3>
            <p>
              Immerse yourself in the heart of nature with our premium canvas tents, specially crafted for those seeking the ultimate safari adventure. Our luxury safari tents provide you with a private retreat with unparalleled comfort, featuring plush interiors, king-sized beds, and en-suite bathrooms. Designed to blend seamlessly with nature, each tent offers stunning views and panoramic views of the African wilderness, where the sounds of wildlife lull you into serenity. Perfect for travelers looking for an authentic safari experience without compromising on luxury – a truly unforgettable escape into the wild.
            </p>
            <button className="view-projects-btn">View Projects</button>
          </div>
          <div className="experience-images">
            <div className="image-back">
              <img src="/images/NIGHT.jpg" alt="Safari Tent Background" />
            </div>
            <div className="image-front">
              <img src="/images/angata-camps-5.jpg" alt="Safari Tent" />
            </div>
          </div>
        </div>

        {/* Glamping Experience */}
        <div className="experience-item reverse">
          <div className="experience-content">
            <h3>Luxury Glamping Experiences</h3>
            <p>
              Combining "glamorous" and "camping," our luxury glamping accommodations offer the perfect blend of adventure and comfort. These spacious canvas tents are designed to provide an opulent outdoor experience, featuring plush bedding, elegant furnishings, and all the amenities of a luxury hotel suite. Set against breathtaking natural landscapes, you can enjoy the serenity of nature without sacrificing luxury. Whether you're dropping by the campsite or planning a longer stay, our glamping experiences allow you to connect with the wilderness in the utmost comfort.
            </p>
            <button className="view-projects-btn">View Projects</button>
          </div>
          <div className="experience-images">
            <div className="image-back">
              <img src="/images/aboutSmallImg1-min.JPG" alt="Glamping Tent Background" />
            </div>
            <div className="image-front">
              <img src="/images/aboutSmallImg3.jpg" alt="Glamping Tent Interior" />
            </div>
          </div>
        </div>

        {/* Event Venues */}
        <div className="experience-item">
          <div className="experience-content">
            <h3>Elegant Event Venues</h3>
            <p>
              Our customized stretch tents transform any outdoor setting into an elegant venue, perfect for creating magical moments during your special celebrations. Designed with versatility and style in mind, our event tents feature modular layouts that can be tailored to suit any occasion, from weddings to corporate gatherings. With their flowing, canopy-like structure and high peaks, these tents create an enchanting and sophisticated atmosphere, offering both protection and beauty. Whether you're hosting an intimate gathering or a grand event, our tents provide the perfect backdrop for your special lifetime.
            </p>
            <button className="view-projects-btn">View Projects</button>
          </div>
          <div className="experience-images">
            <div className="image-back">
              <img src="/images/Tukaone-Camp-2.jpg" alt="Event Tent Background" />
            </div>
            <div className="image-front">
              <img src="/images/aboutSmallImg2-min.jpeg" alt="Event Tent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LuxuryExperiences; 